export default import.meta.ROLLDOWN_FILE_URL_319fzemsarld7v_boejaiw